import React from 'react';
import PropTypes from 'prop-types';

function PaginationDot({ active, onClick, index }) {
  return (
    <div
      className={`paginationSwipe${active ? ' active' : ''}`}
      style={{ height: 18, width: 18, cursor: 'pointer' }}
      onClick={(e) => onClick(e, index)}
    >
      <div
        style={{
          backgroundColor: active ? '#8e8e93' : '#c1c1c4',
          height: 8,
          width: 8,
          borderRadius: 999,
          margin: 3,
        }}
      />
    </div>
  );
}

PaginationDot.propTypes = {
  active: PropTypes.bool.isRequired,
  index: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
};

export { PaginationDot };
